var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefundStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2647_3688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0373 13.9941H3.38269V32.0067H33.0373V13.9941Z",
    fill: "white",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.07324 10.4834H7.92453V13.5914C7.92453 15.4802 6.38771 17.017 4.49889 17.017C2.61006 17.017 1.07324 15.4802 1.07324 13.5914V10.4834Z",
    fill: "#D1D5DB",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.92456 10.4834H14.7758V13.5914C14.7758 15.4802 13.239 17.017 11.3502 17.017C9.46138 17.017 7.92456 15.4802 7.92456 13.5914V10.4834Z",
    fill: "white",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7844 10.4834H21.6357V13.5914C21.6357 15.4802 20.0989 17.017 18.2101 17.017C16.3212 17.017 14.7844 15.4802 14.7844 13.5914V10.4834Z",
    fill: "#D1D5DB",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6357 10.4834H28.487V13.5914C28.487 15.4802 26.9502 17.017 25.0614 17.017C23.1726 17.017 21.6357 15.4802 21.6357 13.5914V10.4834Z",
    fill: "white",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4869 10.4834H35.3382V13.5914C35.3382 15.4802 33.8014 17.017 31.9126 17.017C30.0238 17.017 28.4869 15.4802 28.4869 13.5914V10.4834Z",
    fill: "#D1D5DB",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4047 21.9102H11.0153V32.0154H25.4047V21.9102Z",
    fill: "#D1D5DB",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0153 5.87207H6.216L1.07324 10.4825H7.92453L11.0153 5.87207Z",
    fill: "#D1D5DB",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.806 5.87207H11.0152L7.92444 10.4825H14.7843L15.806 5.87207Z",
    fill: "white",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6053 5.87207H15.806L14.7843 10.4825H21.6356L20.6053 5.87207Z",
    fill: "#D1D5DB",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4047 5.87207H20.6053L21.6356 10.4825H28.4869L25.4047 5.87207Z",
    fill: "white",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.204 5.87207H25.4047L28.4869 10.4825H35.3468L30.204 5.87207Z",
    fill: "#D1D5DB",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.204 1.07324H6.21594V5.87258H30.204V1.07324Z",
    fill: "white",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2647_3688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.42,
    height: 33.0888,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefundStore);
export default __webpack_public_path__ + "static/media/icon_refund_store.d5ce6091a526b17acf51a90bfb65112c.svg";
export { ForwardRef as ReactComponent };